module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-desktop@3x-19f92ecbe756d87ebcce3cb16bea099d.jpg";